import { render, staticRenderFns } from "./zarinpal.vue?vue&type=template&id=6d362867&scoped=true&"
import script from "./zarinpal.vue?vue&type=script&lang=js&"
export * from "./zarinpal.vue?vue&type=script&lang=js&"
import style0 from "./zarinpal.vue?vue&type=style&index=0&id=6d362867&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d362867",
  null
  
)

export default component.exports